import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  activeTabItem: "calllogs"
}
export const sliceKey = "activeTabView"
export const activeTabViewSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    activeTabView: (state, { payload }) => {
      try {
        state.activeTabItem = payload.activeTabItem
      } catch (e) {
        console.log(e)
      }
    },
    clearActiveTabValue: (state) => {
      state.activeTabItem = "calllogs"
    }
  }
})
export const { activeTabView, clearActiveTabValue } = activeTabViewSlice.actions
export default activeTabViewSlice.reducer
